var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: {
      title: _vm.modalTitle,
      showCustomTitle: _vm.isEdittingLocked,
      withBgClickEvent: false,
    },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u(
      [
        {
          key: "titleLine",
          fn: function () {
            return [_vm._t("customHeader", null, { title: _vm.modalTitle })]
          },
          proxy: true,
        },
        {
          key: "content",
          fn: function () {
            return [
              _c("ValidationObserver", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ invalid, handleSubmit }) {
                        return [
                          _c("ValidationProvider", {
                            ref: "projectTitleInput",
                            attrs: {
                              rules: "required_field|max:25",
                              name: "Client title",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c("FormGroup", {
                                        staticClass: "mb-4",
                                        attrs: {
                                          errors: errors,
                                          name: "project_title",
                                          placeholder: "Enter title",
                                          disabled: _vm.isEdittingLocked,
                                          inputClass: "fullwidthInput",
                                          isIcon: false,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "title",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "p",
                                                    { staticClass: "mb-2" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "required-icon",
                                                        },
                                                        [_vm._v("*")]
                                                      ),
                                                      _vm._v(" Project title "),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: _vm.project.name,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.project, "name", $$v)
                                          },
                                          expression: "project.name",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c(
                            "div",
                            { staticClass: "flex flex-col justify-between" },
                            [
                              _c("p", { staticClass: "mb-2" }, [
                                _c("span", { staticClass: "required-icon" }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v("Timeline"),
                              ]),
                              _c(
                                "div",
                                { staticClass: "flex flex-row gap-7" },
                                [
                                  _c("ValidationProvider", {
                                    ref: "startDateValidator",
                                    staticClass: "w-6/12 mr-3",
                                    attrs: {
                                      id: "start_date",
                                      rules: "required_field|noPastDate",
                                      name: "Start date",
                                      vid: "start_date",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors, failed }) {
                                            return [
                                              _c(
                                                "FormGroup",
                                                {
                                                  staticClass: "mb-4",
                                                  attrs: {
                                                    errors: errors,
                                                    name: "start_date",
                                                    inputClass:
                                                      "border-lg rounded-m",
                                                    id: "startDate",
                                                  },
                                                },
                                                [
                                                  _c("FormDatepicker", {
                                                    attrs: {
                                                      name: "start date",
                                                      placeholder:
                                                        "Select start date",
                                                      invalid: failed,
                                                      heightClass:
                                                        "datePickerHeight",
                                                      disabled:
                                                        _vm.isEdittingLocked,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.project.start_date,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.project,
                                                          "start_date",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "project.start_date",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("ValidationProvider", {
                                    ref: "endDateValidator",
                                    staticClass: "w-6/12",
                                    attrs: {
                                      rules:
                                        "noBeforeDate:@start_date,@ongoing|required_field",
                                      name: "End date",
                                      vid: "end_date",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors, failed }) {
                                            return [
                                              _c(
                                                "FormGroup",
                                                {
                                                  staticClass: "mb-4",
                                                  attrs: {
                                                    errors: errors,
                                                    id: "endDate",
                                                    inputClass: "font-600",
                                                    name: "end_date",
                                                  },
                                                },
                                                [
                                                  _c("FormDatepicker", {
                                                    attrs: {
                                                      placeholder:
                                                        "Select end date",
                                                      name: "end_date",
                                                      heightClass:
                                                        "datePickerHeight",
                                                      calendarClass:
                                                        "right-0 sm:right-0 sm:left-auto left-0 sm:left-auto",
                                                      invalid: failed,
                                                      disabled:
                                                        _vm.isEdittingLocked,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.project.end_date,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.project,
                                                          "end_date",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "project.end_date",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c("ValidationProvider", {
                            attrs: { rules: "required_field", name: "Country" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "FormGroup",
                                        {
                                          staticClass: "mb-4",
                                          attrs: {
                                            title: "Country",
                                            id: "countryId",
                                            name: "countrySelect",
                                            errors: errors,
                                            inputClass: "fullwidthInput",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "title",
                                                fn: function () {
                                                  return [
                                                    _c("p", [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "required-icon",
                                                        },
                                                        [_vm._v("*")]
                                                      ),
                                                      _vm._v("Country"),
                                                    ]),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("ProfileCountrySelect", {
                                            staticClass: "mt-2",
                                            attrs: {
                                              getcontainerStyle:
                                                "customFullWidthInput",
                                              disabled: _vm.isEdittingLocked,
                                            },
                                            model: {
                                              value: _vm.project.country,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.project,
                                                  "country",
                                                  $$v
                                                )
                                              },
                                              expression: "project.country",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("RegionInput", {
                            staticClass: "mb-4",
                            attrs: {
                              id: "regionInput",
                              title: "Region",
                              isIcon: false,
                              shouldFullWidth: "customFullWidthInput",
                              getcontainerStyle: "customFullWidthInput",
                              countries: _vm.project.country,
                              disabled: _vm.isEdittingLocked,
                            },
                            model: {
                              value: _vm.project.state,
                              callback: function ($$v) {
                                _vm.$set(_vm.project, "state", $$v)
                              },
                              expression: "project.state",
                            },
                          }),
                          _c("ValidationProvider", {
                            attrs: { name: "City", rules: "name_with_spaces" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c("FormGroup", {
                                        staticClass: "mb-4",
                                        attrs: {
                                          inputClass: "fullwidthInput",
                                          title: "City",
                                          placeholder: "Enter city",
                                          isIcon: false,
                                          disabled: _vm.isEdittingLocked,
                                          errors: errors,
                                        },
                                        model: {
                                          value: _vm.project.city,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.project,
                                              "city",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "project.city",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("LocationModal"),
                          !_vm.isManager
                            ? _c("ValidationProvider", {
                                attrs: { name: "Manager" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors, failed }) {
                                        return [
                                          _c(
                                            "FormGroup",
                                            {
                                              staticClass: "mb-4",
                                              attrs: {
                                                errors: errors,
                                                title: "Manager",
                                                name: "manager",
                                              },
                                            },
                                            [
                                              _c("ManagersMultiselect", {
                                                attrs: {
                                                  value:
                                                    _vm.selectedManagersIds,
                                                  invalid: failed,
                                                  multiple: false,
                                                  placeholder:
                                                    "Select a manager",
                                                  title: "Manager",
                                                  disabled:
                                                    _vm.isEdittingLocked,
                                                },
                                                on: {
                                                  input: _vm.handleManagerInput,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : _vm._e(),
                          _c(
                            "FormGroup",
                            { staticClass: "mb-4", attrs: { title: "Skills" } },
                            [
                              _c("CustomSkillsMultiselect", {
                                attrs: {
                                  previouslyChosenSkillsIds:
                                    _vm.projectSkillsIds,
                                  disabled: _vm.isEdittingLocked,
                                  getParentContainer: "customWidthInput",
                                  max: 10,
                                },
                                on: { skillsListUpdated: _vm.updateSkills },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ skill }) {
                                        return [
                                          _vm.isPersonalSkill(skill)
                                            ? _c("SkillMultiselectItem", {
                                                attrs: {
                                                  labelText:
                                                    "Your personal skill",
                                                  skillName: skill.name,
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm.personalSkillsChosenWarning
                                ? _c("FormError", [
                                    _c("span", { staticClass: "font-bold" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.personalSkillsChosenWarning
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _vm._v(
                                      " - will be available to everyone within the company "
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "FormGroup",
                            { staticClass: "mb-4", attrs: { title: "Tags" } },
                            [
                              _c("CustomTagsMultiselect", {
                                attrs: {
                                  previouslyChosenTagsIds: _vm.projectTagsIds,
                                  disabled: _vm.isEdittingLocked,
                                  getParentcontainerStyle: "customWidthInput",
                                  max: 10,
                                },
                                on: { tagsListUpdated: _vm.updateTags },
                              }),
                            ],
                            1
                          ),
                          _c("p", { staticClass: "mb-2" }, [
                            _c("span", { staticClass: "required-icon" }, [
                              _vm._v("* "),
                            ]),
                            _vm._v("Budget"),
                          ]),
                          _c(
                            "div",
                            { staticClass: "flex justify-between gap-7" },
                            [
                              _c("ValidationProvider", {
                                ref: "minBudgetValidator",
                                staticClass: "w-full",
                                attrs: {
                                  rules: "noSmaller:@max_budget|required_field",
                                  name: "Min budget",
                                  delay: "1000",
                                  vid: "min_budget",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors, failed }) {
                                        return [
                                          _c(
                                            "FormGroup",
                                            {
                                              staticClass: "mb-4",
                                              attrs: {
                                                errors: errors,
                                                disabled: _vm.isEdittingLocked,
                                                id: "min_budget",
                                              },
                                            },
                                            [
                                              _c("FormInputGroup", {
                                                attrs: {
                                                  disabled:
                                                    _vm.isEdittingLocked,
                                                  invalid: failed,
                                                  type: "number",
                                                  placeholder: "Min",
                                                  inputClasses:
                                                    "pl-2 w-full rounded-m",
                                                  suffix: "$",
                                                },
                                                model: {
                                                  value: _vm.project.min_budget,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.project,
                                                      "min_budget",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "project.min_budget",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("ValidationProvider", {
                                ref: "maxBudgetValidator",
                                staticClass: "w-full",
                                attrs: {
                                  name: "Max budget",
                                  vid: "max_budget",
                                  rules: "noBigger:@min_budget|required_field",
                                  delay: "1000",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors, failed }) {
                                        return [
                                          _c(
                                            "FormGroup",
                                            {
                                              staticClass: "mb-4",
                                              attrs: {
                                                errors: errors,
                                                id: "max_budget",
                                              },
                                            },
                                            [
                                              _c("FormInputGroup", {
                                                attrs: {
                                                  invalid: failed,
                                                  disabled:
                                                    _vm.isEdittingLocked,
                                                  type: "number",
                                                  placeholder: "Max",
                                                  inputClasses: "pl-2 w-full",
                                                  suffix: "$",
                                                },
                                                model: {
                                                  value: _vm.project.max_budget,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.project,
                                                      "max_budget",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "project.max_budget",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                          _c("ValidationProvider", {
                            staticClass: "w-full",
                            attrs: {
                              name: "Description",
                              rules: "max:40",
                              vid: "description",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "FormGroup",
                                        {
                                          staticClass: "mb-4",
                                          attrs: {
                                            title: "Description",
                                            errors: errors,
                                          },
                                        },
                                        [
                                          _c("FormTextarea", {
                                            attrs: {
                                              rows: 3,
                                              customBorderClass: "borderTen",
                                              name: "description",
                                              placeholder:
                                                "Describe the Client",
                                              disabled: _vm.isEdittingLocked,
                                            },
                                            model: {
                                              value: _vm.project.description,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.project,
                                                  "description",
                                                  $$v
                                                )
                                              },
                                              expression: "project.description",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("ValidationProvider", {
                            staticClass: "w-full",
                            attrs: {
                              name: "Notes",
                              rules: "max:50",
                              vid: "notes",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "FormGroup",
                                        {
                                          attrs: {
                                            title: "Notes",
                                            errors: errors,
                                          },
                                        },
                                        [
                                          _c("FormTextarea", {
                                            attrs: {
                                              rows: 3,
                                              customBorderClass: "borderTen",
                                              name: "Notes",
                                              placeholder: "Notes",
                                              disabled: _vm.isEdittingLocked,
                                            },
                                            model: {
                                              value: _vm.project.extra_notes,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.project,
                                                  "extra_notes",
                                                  $$v
                                                )
                                              },
                                              expression: "project.extra_notes",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("ModalSectionsDivider"),
                          _vm._t("project_actions_slot"),
                          _c(
                            "div",
                            { staticClass: "flex pt-5 justify-end" },
                            [
                              _vm.show_cancel_draft_actions
                                ? [
                                    _vm.isActiveProject
                                      ? _c("UIButton", {
                                          staticClass: "mr-3",
                                          attrs: {
                                            variant: "outline",
                                            id: "cancelProject",
                                            buttonClasses: "customButtonCard",
                                            buttonText: "Cancel",
                                          },
                                          on: { click: _vm.closeModal },
                                        })
                                      : _c("UIButton", {
                                          staticClass: "mr-3",
                                          attrs: {
                                            variant: "outline",
                                            disabled: invalid,
                                            fullWidth: true,
                                            id: "draftProject",
                                            buttonClasses: "customButtonCard",
                                            buttonText: "Save as draft",
                                          },
                                          on: {
                                            click: function ($event) {
                                              handleSubmit(_vm.onSubmit(true))
                                            },
                                          },
                                        }),
                                  ]
                                : _vm._e(),
                              _vm.data
                                ? _c("UIButton", {
                                    attrs: {
                                      variant: "black",
                                      disabled:
                                        invalid ||
                                        !(
                                          _vm.project.name &&
                                          _vm.project.max_budget &&
                                          _vm.project.min_budget &&
                                          _vm.project.country &&
                                          _vm.project.start_date &&
                                          _vm.project.end_date
                                        ),
                                      buttonText: _vm.buttonText,
                                      buttonClasses: "customButtonCard",
                                      id: "createProjectButton",
                                    },
                                    on: {
                                      click: function ($event) {
                                        handleSubmit(_vm.onSubmit(false))
                                      },
                                    },
                                  })
                                : _c("UIButton", {
                                    attrs: {
                                      disabled: invalid,
                                      buttonText: _vm.buttonText,
                                      variant: "black",
                                      buttonClasses: "customButtonCard",
                                      id: "createNewProj",
                                    },
                                    on: {
                                      click: function ($event) {
                                        handleSubmit(_vm.onSubmit(false))
                                      },
                                    },
                                  }),
                            ],
                            2
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }